import React, { useMemo } from 'react';
import { MapContainer, TileLayer, Marker, Popup, useMap } from 'react-leaflet';
import { IFinalData } from '../utils/data-mapping';
import { Icon } from 'leaflet';
import { departmentPosition } from '../utils/departmentGeocode';

interface IMapProps {
    data: IFinalData[];
    department?: string;
}

const Map: React.FC<IMapProps> = React.memo(({ data, department }) => {
    function SetViewOnClick({ coords }: any) {
        const map = useMap();
        if (coords) {
            map.setView(coords, 9);
        }

        return null;
    }
    return useMemo(() => {
        const position = departmentPosition(department || '100');
        return (
            <MapContainer style={{ height: '100vh', width: '100wh' }} center={position} zoom={department ? 8 : 6} scrollWheelZoom={true}>
                <TileLayer
                    attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />
                {data.map((e) => {
                    if (!e.coords) {
                        console.log(e.id);
                    }
                    return (
                        <React.Fragment key={e.id}>
                            <Marker
                                position={[Number(e.coords.lat), Number(e.coords.lng)]}
                                icon={
                                    new Icon({
                                        iconUrl: `https://chart.apis.google.com/chart?chst=d_map_pin_letter&chld=%E2%80%A2|${e.color.replace(
                                            '#',
                                            ''
                                        )}&chf=a,s,ee00FFFF`,
                                        iconSize: [14, 25],
                                        iconAnchor: [15, 15],
                                    })
                                }
                            >
                                <Popup>
                                    <div>
                                        <p>Adresse : {e.full_address}</p>
                                        <p>Nombre de logements : {e.total}</p>
                                        <p>Bailleur : {e.name}</p>
                                    </div>
                                </Popup>
                            </Marker>
                        </React.Fragment>
                    );
                })}
                <SetViewOnClick coords={department ? departmentPosition(department || '100') : null} />
            </MapContainer>
        );
    }, [department, data]);
});

export default Map;
